import * as yup from 'yup';

function email(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_EMAIL_FIELD_IS_REQUIRED',
      defaultMessage: 'Email is required',
    }),
  );
}

function firstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_FIRST_NAME_FIELD_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function lastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_LAST_NAME_FIELD_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function enabled(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'CREATEFORM_STATUS_FIELD_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function role(formatMessage) {
  return yup.object().required(
    formatMessage({
      id: 'CREATEFORM_ROLE_FIELD_IS_REQUIRED',
      defaultMessage: 'Role is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      email: email(formatMessage),
      firstName: firstName(formatMessage),
      lastName: lastName(formatMessage),
      enabled: enabled(formatMessage),
      role: role(formatMessage),
    })
    .required();

export default validationSchema;
